import { useNavigate } from "react-router-dom";

const REASONS = {
  track_limit: {
    title: "You've hit the free tier",
    sub: "You've reached your 25-track limit. Upgrade to Pro for unlimited tracks plus auto-import, bulk import, and verify magic.",
  },
  import_link: {
    title: "Unlock auto-import",
    sub: "Paste any Apple Music, Tidal, or YouTube link and Pro auto-fills the metadata — title, ISRC, duration, release date, artwork.",
  },
  bulk_import: {
    title: "Unlock bulk artist import",
    sub: "Connect your Apple Music artist profile and pull your entire discography in one tap with full metadata.",
  },
  auto_verify: {
    title: "Unlock auto-verification",
    sub: "Run automated cross-references against iTunes to surface gaps in your registration data.",
  },
  default: {
    title: "Unlock Pro",
    sub: "This is a Pro feature. Start a 14-day free trial — no credit card required.",
  },
};

export default function PaywallModal({ open, onClose, reason = "default" }) {
  const nav = useNavigate();
  if (!open) return null;
  const r = REASONS[reason] || REASONS.default;

  return (
    <div className="modal-backdrop" onClick={onClose} data-testid="paywall-modal">
      <div className="modal-card" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 520, padding: "32px 28px" }}>
        <div className="eyebrow" style={{ color: "var(--accent)" }}>— Pro Feature</div>
        <h2 className="serif" style={{ fontSize: 38, lineHeight: 1.05, margin: "10px 0 14px" }} data-testid="paywall-title">
          {r.title}
        </h2>
        <p style={{ color: "var(--text-mute)", lineHeight: 1.6, marginBottom: 22 }}>{r.sub}</p>

        <ul style={{ listStyle: "none", padding: 0, margin: "0 0 26px", borderTop: "1px solid var(--border-soft)" }}>
          {[
            "Unlimited tracks",
            "Bulk artist import — Apple Music",
            "Streaming-link auto-fill",
            "Auto cross-reference verification",
            "14-day free trial · no credit card",
          ].map((p) => (
            <li
              key={p}
              style={{
                padding: "11px 0",
                borderBottom: "1px solid var(--border-soft)",
                fontSize: 14,
                color: "var(--text)",
                display: "flex",
                gap: 10,
                alignItems: "center",
              }}
            >
              <span style={{ color: "var(--accent)", fontFamily: "var(--mono)", fontSize: 11 }}>✓</span>
              {p}
            </li>
          ))}
        </ul>

        <div style={{ display: "flex", gap: 10, flexDirection: "column" }}>
          <button
            className="btn btn-primary btn-block"
            data-testid="paywall-upgrade-btn"
            onClick={() => { onClose?.(); nav("/pricing"); }}
          >
            Start 14-Day Free Trial →
          </button>
          <button className="btn btn-ghost btn-block" onClick={onClose} data-testid="paywall-later-btn">
            Maybe Later
          </button>
        </div>

        <p style={{ textAlign: "center", marginTop: 16, fontFamily: "var(--mono)", fontSize: 10, color: "var(--text-fade)", letterSpacing: "0.10em" }}>
          No card required · Cancel anytime · $8/mo after trial
        </p>
      </div>
    </div>
  );
}
